import styled from '@emotion/styled';
import { StyledHelpText } from '../HelpText';

export const StyledInvalidMessage = styled(StyledHelpText)(({ theme }) => ({
    color: theme.colors.error,
    [`+ ${StyledHelpText}`]: {
        display: 'none',
    },
}));
